import {takeEvery} from 'redux-saga/effects'
import {
  ADD_MANY_TEST,
  ADD_SINGLE_TEST,
  ADD_TEST_RESOURCE,
  ADD_TEST_TYPE,
  ASSIGN_MARKS_TO_ALL_TESTS,
  ASSIGN_TOP_TESTS,
  DELETE_MANY_TESTS,
  DELETE_SINGLE_TEST,
  DELETE_TEST_RESOURCE,
  DELETE_TEST_TYPE,
  EXPORT_ASSESSMENT_REPORT,
  EXPORT_OVERVIEW_REPORT,
  GET_ASSESSMENT_GRID,
  GET_ONE_TEST,
  GET_STUDENT_TESTS,
  GET_TESTS,
  GET_TEST_RESOURCES,
  GET_TEST_RESULTS,
  GET_TEST_TYPE,
  GET_TEST_TYPES,
  GRADEWISE_TEST_LIMIT,
  GRADEWISE_TEST_TYPES,
  PRINT_TEST_PDF,
  PRINT_TEST_RESULT_PDF,
  PUBLISH_MANY_TESTS,
  RESET_QUIZ,
  SAVE_ASSESSMENT_GRID,
  SEND_TEST_NOTIFICATION,
  SEND_TEST_SMS,
  UPDATE_TEST,
  UPDATE_TEST_RESULT,
  UPDATE_TEST_TYPE,
} from 'setup/redux/Actions/Test/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_TESTS, fetchData)
  yield takeEvery(GET_ONE_TEST, fetchData)
  yield takeEvery(DELETE_SINGLE_TEST, fetchData)
  yield takeEvery(DELETE_MANY_TESTS, fetchData)
  yield takeEvery(PUBLISH_MANY_TESTS, fetchData)
  yield takeEvery(GET_TEST_RESOURCES, fetchData)
  yield takeEvery(ADD_TEST_RESOURCE, fetchData)
  yield takeEvery(DELETE_TEST_RESOURCE, fetchData)
  yield takeEvery(ADD_SINGLE_TEST, fetchData)
  yield takeEvery(UPDATE_TEST, fetchData)
  yield takeEvery(GRADEWISE_TEST_LIMIT, fetchData)
  yield takeEvery(ASSIGN_TOP_TESTS, fetchData)
  yield takeEvery(GET_ASSESSMENT_GRID, fetchData)
  yield takeEvery(SAVE_ASSESSMENT_GRID, fetchData)
  yield takeEvery(GET_TEST_RESULTS, fetchData)
  yield takeEvery(UPDATE_TEST_RESULT, fetchData)
  yield takeEvery(ASSIGN_MARKS_TO_ALL_TESTS, fetchData)
  yield takeEvery(SEND_TEST_NOTIFICATION, fetchData)
  yield takeEvery(SEND_TEST_SMS, fetchData)
  yield takeEvery(PRINT_TEST_PDF, fetchData)
  yield takeEvery(PRINT_TEST_RESULT_PDF, fetchData)
  yield takeEvery(EXPORT_ASSESSMENT_REPORT, fetchData)
  yield takeEvery(EXPORT_OVERVIEW_REPORT, fetchData)
  yield takeEvery(GRADEWISE_TEST_TYPES, fetchData)
  yield takeEvery(ADD_MANY_TEST, fetchData)
  yield takeEvery(RESET_QUIZ, fetchData)
  yield takeEvery(GET_TEST_TYPES, fetchData)
  yield takeEvery(GET_TEST_TYPE, fetchData)
  yield takeEvery(ADD_TEST_TYPE, fetchData)
  yield takeEvery(UPDATE_TEST_TYPE, fetchData)
  yield takeEvery(DELETE_TEST_TYPE, fetchData)
  yield takeEvery(GET_STUDENT_TESTS, fetchData)
}

export default dataSaga
